import {IHttpResponse} from './Service';
import {AuthenticatedService} from './AuthenticatedService';
import {Page} from '../Models';

export interface Exception {
  id: number;
  date: Date;
  message: string;
  notes: string;
  stackTrace?: string;
  innerError: Exception | null;
}

export class ExceptionService extends AuthenticatedService {
  public list = async (page: number = 1): Promise<IHttpResponse<Page<Exception>>> => {
    const exceptions = await this.getAuth<Page<Exception>>(
      `errors?page=${page}`,
    );

    return exceptions;
  }

  public byId = async (id: number): Promise<IHttpResponse<Exception>> => {
    const exception = await this.getAuth<Exception>(
      `errors/${id}`,
    );

    return exception;
  }
}
